import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const BM_SIZES = async (e) => {
  const res = await axios.get(BASE_URL + `/bm/sizes/${e.queryKey[1]?.size || ''}`);
  return res.data;
};


